module.exports = __webpack_public_path__ + "img/press-1.d7241015.jpg";